var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 36,
    viewBox: "0 0 16 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C5.79086 8 4 6.20914 4 4C4 1.79086 5.79086 -2.7141e-07 8 -1.74846e-07C10.2091 -7.8281e-08 12 1.79086 12 4C12 6.20914 10.2091 8 8 8Z",
    fill: "#196BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0715 27.9287C15.4619 28.3191 15.4617 28.9522 15.0715 29.3428L8.70725 35.707C8.31673 36.0976 7.68372 36.0976 7.29319 35.707L0.928934 29.3428C0.538706 28.9522 0.538509 28.3191 0.928934 27.9287C1.31936 27.5383 1.95245 27.5385 2.343 27.9287L7.00022 32.5859L7.00022 5L9.00022 5L9.00022 32.5859L13.6574 27.9287C14.048 27.5385 14.6811 27.5383 15.0715 27.9287Z",
    fill: "#196BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.a9c25fa794b63fb0f6cdbda3bdbd3ca9.svg";
export { ForwardRef as ReactComponent };